export default __webpack_public_path__ + "static/media/naganaya.072ef015.jpeg";